import { LitElement, html, unsafeCSS } from 'lit'
import styles from './gallery-skeleton.styles.scss?inline'

/** Number of shimmer tile placeholders to render in the skeleton grid. */
const SKELETON_TILE_COUNT = 8

/**
 * Skeleton loading placeholder for the gallery.
 *
 * Renders a shimmer header and 8 shimmer tile placeholders laid out with
 * the same responsive CSS grid as `<gallery-tiles-view>`.
 * Uses `<chameleon-skeleton>` for all placeholder elements.
 */
export class GallerySkeleton extends LitElement {
  static tagName = 'gallery-skeleton'
  static override styles = unsafeCSS(styles)

  override render() {
    return html`
      <div class="skeleton-header">
        <chameleon-skeleton variant="rectangle" width="260" size="small"></chameleon-skeleton>
        <chameleon-skeleton variant="rectangle" width="420" size="xlarge"></chameleon-skeleton>
      </div>
      <div class="skeleton-toolbar">
        <chameleon-skeleton variant="square" size="small"></chameleon-skeleton>
        <chameleon-skeleton variant="rectangle" width="120" size="xsmall"></chameleon-skeleton>
      </div>
      <div class="skeleton-grid">
        ${Array.from(
          { length: SKELETON_TILE_COUNT },
          () => html`<chameleon-skeleton variant="square" size="large" class="skeleton-tile"></chameleon-skeleton>`,
        )}
      </div>
    `
  }
}
